const { createHashHistory } = require('history')

export default createHashHistory()
